export default "__VITE_ASSET__CHHEj$n8__"